<template>
  <div class="memberCenter_wrap ChangeInform" :style="{ height: height }">
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <router-link to="/MemberCenter">首页</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>补充信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="change_inform">
      <div class="title">合同条款内容</div>
      <div>
        <el-form :inline="true" :model="contract" :rules="rules" class="form_table" ref="form" :inline-message="true">
          <el-form-item label="合同编号">
            <span>{{ contract.ContractNumber }}</span>
          </el-form-item>
          <el-form-item label="合同名称">
            <span>{{ contract.ContractTitle }}</span>
          </el-form-item>

          <el-form-item label="甲方名称">
            <span>{{ contract.CompanyName }}</span>
          </el-form-item>
          <el-form-item label="乙方名称">
            <span>{{ contract.SupplierName }}</span>
          </el-form-item>
          <!-- <el-form-item label="合同附件">
            <el-link @click="fnReadPdf(contract.FileId)" :underline="false" style="color: #0361b1; padding-right: 15px"> 预览</el-link>
            <el-link @click="fnDownload(contract.FileId)" :underline="false" style="color: #0361b1"> 下载</el-link>
          </el-form-item> -->
          <el-form-item></el-form-item>
          <el-form-item label="付款方式" prop="PaymentType" class="all_line">
            <el-input v-model="contract.PaymentType" :readonly="true"></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="SupplierContact">
            <el-input v-model="contract.SupplierContact"></el-input>
          </el-form-item>

          <el-form-item label="联系电话" prop="SupplierMobile">
            <el-input v-model="contract.SupplierMobile"></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱" prop="SupplierEmail">
            <el-input v-model="contract.SupplierEmail"></el-input>
          </el-form-item>
          <el-form-item label="联系地址" prop="SupplierAddress">
            <el-input v-model="contract.SupplierAddress"></el-input>
          </el-form-item>
          <el-form-item label="付款比例(%)" class="all_line">
            <span slot="label"><span style="color: #f56c6c; margin-right: 4px">*</span>付款比例 </span>
            <div style="display: none; padding-top: 10px; width: 100%"><i @click="fnAddRatio()" class="el-icon-circle-plus-outline">新增</i></div>
            <div v-for="(item, index) in contract.paymentRatioList" :key="index" style="display: block; padding-top: 10px; width: 100%">
              <i class="el-icon-remove-outline" style="margin-right: 20px; display: none" @click="fnDelRatio(index)">删除</i>
              <el-select :disabled="true" v-model="item.PaymentEntry" @change="RatioChange(item, index)" class="input_select">
                <el-option v-for="(item1, index1) in paymentRatioParamList" :key="index1" :label="item1.text" :value="item1.value"> </el-option>
              </el-select>
              {{ item.PaymentDescribe }}
              <!-- <el-input type="textarea" style="width: 40%" v-model="item.PaymentDescribe" :readonly="true"></el-input> -->
              <el-input-number :controls="false" :disabled="true" style="margin-left: 20px" class="input_number" :min="0" :max="100" v-model="item.Ratio"></el-input-number>
            </div>
          </el-form-item>
          <el-form-item label="开户名">
            <span>{{ contract.SupplierName }}</span>
          </el-form-item>
          <el-form-item label="开户银行" prop="SupplierBankName">
            <el-input v-model="contract.SupplierBankName"></el-input>
          </el-form-item>
          <el-form-item label="银行账号" prop="SupplierBankAccount">
            <el-input v-model="contract.SupplierBankAccount"></el-input>
          </el-form-item>

          <el-form-item label="联行号" prop="SupplierBankApprovalNumber">
            <el-input v-model="contract.SupplierBankApprovalNumber"></el-input>
          </el-form-item>
          <el-form-item label="乙方合同收件联系人、收件联系人电话、收件地址" class="all_line" prop="SupplierInvoiceAddress">
            <el-input v-model="contract.SupplierInvoiceAddress"></el-input>
          </el-form-item>
          <!-- 
          <el-form-item :disabled="true" label="货期(自然日)" prop="DeliveryTerm">
            <el-input-number :controls="false" v-model="contract.DeliveryTerm" :step="1" step-strictly :min="0"> </el-input-number>
            {{ contract.DeliveryTerm }}
          </el-form-item>
          <el-form-item label="安装调试所需日期(自然日)" prop="TestCycle">
            <el-input-number :controls="false" v-model="contract.TestCycle" :step="1" step-strictly :min="0"> </el-input-number>
          </el-form-item>

          <el-form-item label="保修期限" prop="WarrantyPeriod" class="all_line">
            <el-input-number :disabled="true" :controls="false" v-model="contract.WarrantyPeriod" class="input_number" :step="1" step-strictly :min="0"> </el-input-number>
            <el-select :disabled="true" v-model="contract.WarrantyPeriodUnit" placeholder="请选择" class="input_select">
              <el-option v-for="item in contract.WarrantyPeriodUnitList" :key="item.value" :label="item.text" :value="item.value"> </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="相关附件" class="all_line">
            <template slot="label">
              <el-popover placement="top-start" width="400" trigger="hover">
                <div>
                  <p>请严格按照以下要求上传附件，否则将会退回修改！</p>
                  <p>1.附件的文件类型必须为PDF。</p>
                  <p>2.务必按照附件一、附件二的顺序上传附件，以免乱码。</p>
                  <p>3.附件的文件名称统一固定格式为：</p>
                  <p>产品技术规格书</p>
                  <p>货物清单</p>
                  <p>4.附件正文首行必须统一固定格式为：</p>
                  <p>附件一：《产品技术规格书》</p>
                  <p>附件二：《货物清单》</p>
                  <p>（切记请勿添加其他任何文字/符号等内容）</p>
                </div>
                <img class="icon_tips2" src="@/assets/img/icon_tips2.png" alt slot="reference" />
              </el-popover>
              <span style="padding-right: 20px">相关附件</span>
            </template>
            <div class="file_wrap">
              <el-upload
                :action="uploadUrl"
                :before-remove="removeConfirm"
                :before-upload="beforeUpload"
                :on-remove="handleRemove"
                :auto-upload="true"
                :file-list="fileList"
                :data="{}"
                :http-request="uploadTechnicalFile"
                ref="uploader"
              >
                <el-button size="mini" type="primary" plain>点击上传</el-button>
                <el-button size="mini" type="primary" @click="downloadTemplate()">下载模板</el-button>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="title">待发货清单</div>
      <el-form class="rule-form" style="overflow: auto; width: 100%; margin: 0" :inline="true" ref="form1" :inline-message="true">
        <table class="statistics_table">
          <tbody>
            <tr>
              <th style="width: 6rem">计划编号</th>
              <th style="width: 6rem">乙方需求货物名称</th>
              <th style="width: 10rem"><font color="red">*</font>货物名称（与发票保持一致）</th>
              <th style="width: 10rem"><font color="red">*</font>规格型号（与发票保持一致）</th>
              <th style="width: 10rem"><font color="red">*</font>品牌</th>
              <th style="width: 6rem">单价(元)</th>
              <th style="width: 5rem"><font color="red">*</font>数量</th>
              <th style="width: 6rem">金额合计（元）</th>
              <th style="width: 10rem"><font color="red">*</font>货期(自然日)</th>
              <th style="width: 10rem"><font color="red">*</font>安装调试所需日期(自然日)</th>
              <th style="width: 15rem"><font color="red">*</font>保修期限</th>
              <th style="width: 10rem">备注</th>
            </tr>
            <template v-for="(data, index) in instrumentList">
              <tr :key="index">
                <td>{{ data.PlanCode }}</td>
                <td>{{ data.InstrumentName }}</td>
                <td>
                  {{ data.SupplierInstrumentName }}
                  <!-- <el-input  :readonly="true" v-model="data.SupplierInstrumentName" style="width: 9rem"></el-input> -->
                </td>
                <td>
                  {{ data.SupplierSpecification }}
                  <!-- <el-input  :readonly="true" v-model="data.SupplierSpecification" style="width: 10rem"></el-input> -->
                </td>
                <td>
                  {{ data.Trademark }}
                  <!-- <el-input  :readonly="true" v-model="data.Trademark" style="width: 10rem"></el-input> -->
                </td>
                <td>
                  <!-- <el-input-number
                    style="width: 6rem"
                    v-if="contract.PurchaseMethod == 1 || contract.PurchaseMethod >= 6"
                    :controls="false"
                    v-model="data.Price"
                    @change="fnGetTotal(data, index)"
                    :precision="2"
                    :min="0"
                    :disabled="true"
                  >
                  </el-input-number>
                  <span v-else>{{ data.Price }}</span> -->
                  {{ data.Price }}
                </td>
                <td>
                  <!-- <el-input-number
                    style="width: 5rem"
                    v-if="contract.PurchaseMethod == 1 || contract.PurchaseMethod >= 6"
                    :controls="false"
                    v-model="data.Count"
                    @change="fnGetTotal(data, index)"
                    :step="1"
                    step-strictly
                    :min="0"
                    :disabled="true"
                  >
                  </el-input-number>
                  <span v-else>{{ data.Count }}</span> -->
                  {{ data.Count }}
                </td>
                <td>{{ data.Total }}</td>
                <td>
                  <el-input-number :controls="false" v-model="data.DeliveryTerm" :step="1" step-strictly :min="1"> </el-input-number>
                  <!-- {{ data.DeliveryTerm }} -->
                </td>
                <td>
                  <el-input-number :controls="false" v-model="data.TestCycle" :step="1" step-strictly :min="0"> </el-input-number>
                </td>
                <td>
                  <div style="display: flex">
                    <el-input-number :disabled="false" :controls="false" v-model="data.WarrantyPeriod" class="input_number1" :step="1" step-strictly :min="1"> </el-input-number>
                    <el-select :disabled="false" v-model="data.WarrantyPeriodUnit" placeholder="请选择" class="input_select">
                      <el-option v-for="item in contract.WarrantyPeriodUnitList" :key="item.value" :label="item.text" :value="item.value"> </el-option>
                    </el-select>
                  </div>
                </td>
                <td>
                  <el-input v-model="data.Remark" style="width: 10rem"></el-input>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </el-form>
      <div class="btn_wrap changeInform_btn_wrap">
        <span class="btn_1" @click="fnGoBack()">返回</span>
        <span v-if="contract.FillType == 1" class="btn_1" style="margin-right: 8px" @click="fnReadPdf1()">保存并预览合同</span>
        <span class="btn_1" @click="fnSave()">提交</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contractId: this.$route.query.contractId,
      form: {},
      contract: {},
      instrumentList: [],
      paymentRatioParamList: [],
      businessType: 28,
      fileList: [],
      rules: {
        SupplierContact: [{ required: true, message: '请输入联系人!', trigger: 'blur' }],
        SupplierBankName: [{ required: true, message: '请输入开户银行!', trigger: 'blur' }],
        SupplierBankAccount: [{ required: true, message: '请输入银行账号!', trigger: 'blur' }],
        SupplierBankApprovalNumber: [{ required: true, message: '请输入联行号!', trigger: 'blur' }],
        SupplierInvoiceAddress: [{ required: true, message: '请输入合同、发票收货地址!', trigger: 'blur' }],
        SupplierMobile: [{ required: true, message: '请输入联系电话!', trigger: 'blur' }],
        SupplierEmail: [{ required: true, message: '请输入邮箱!', trigger: 'blur' }],
        SupplierAddress: [{ required: true, message: '请输入联系地址!', trigger: 'blur' }],
        AdvanceFee: [{ required: true, message: '请输入预收款比例!', trigger: 'blur' }],
        AcceptanceFee: [{ required: true, message: '请输入验收款比例!', trigger: 'blur' }],
        WarrantyFee: [{ required: true, message: '请输入质保款比例!', trigger: 'blur' }]
        // DeliveryTerm: [{ required: true, message: '请输入货期!', trigger: 'blur' }],
        // TestCycle: [{ required: true, message: '请输入测试周期!', trigger: 'blur' }],
        // WarrantyPeriod: [{ required: true, message: '请输入保修期限!', trigger: 'blur' }]
      },
      uploadUrl: '',
      height: '0px'
    }
  },
  mounted() {
    let change_inform = document.getElementsByClassName('MemberHeader')[0]
    this.height = window.innerHeight - change_inform.clientHeight - 17 + 'px'
    this.getData()
  },
  methods: {
    getData() {
      let config = {
        params: {
          contractId: this.contractId
        }
      }
      this.getRequest('/Contract/EditContract', config).then((res) => {
        if (res.data.errcode == 0) {
          this.businessType = res.data.businessType
          this.contract = res.data.contract
          this.form = res.data.contract
          this.instrumentList = res.data.instrumentList
          this.fileList = res.data.fileList
          this.paymentRatioParamList = res.data.paymentRatioParamList
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    fnGetTotal(data, index) {
      let price = data.Price == '' || data.Price == undefined || isNaN(data.Price) ? 0 : parseFloat(data.Price)
      let count = data.Count == '' || data.Count == undefined || isNaN(data.Count) ? 0 : parseInt(data.Count)
      data.Total = price * count
      this.instrumentList[index].Total = price * count
    },
    uploadTechnicalFile(params) {
      let file = params.file
      var data = new window.FormData()
      let loginToken = window.localStorage.getItem('loginToken')
      data.append('file', params.file)
      data.append('businessType', this.businessType)
      data.append('businessKeyId', this.contractId)
      data.append('savePath', '/ContractFile')
      data.append('loginToken', loginToken)

      this.uploadFileRequest('/Contract/UploadContractRelatedFile', data).then((res) => {
        if (res.data.errcode == 0) {
          var obj = {
            fileId: res.data.FileList[0].id,
            name: res.data.FileList[0].fileName
          }
          console.log(obj)
          this.fileList.push(obj)
          params.onSuccess()
          console.log(this.fileList)
        } else {
          this.$message.error(res.data.errmsg)
          let index = this.fileList.findIndex((item) => item.uid === file.uid)
          if (index > 0) this.fileList.splice(index, 1)
        }
      })
    },

    // 点击x时执行的钩子函数
    removeConfirm(file, fileList) {
      console.log(file)
      if (file.status == 'success') {
        return this.$confirm(`确定删除 ${file.name}？`)
      }
    },
    handleRemove(file, fileList) {
      console.log(file)
      console.log(fileList)
      if (typeof file.fileId != 'undefined') {
        this.postRequest('/Common/DeleteBusinessAttachmentByFileId', {
          fileId: file.fileId
        }).then((res) => {
          if (res.data.errcode == 0) {
            this.fileList.splice(
              this.fileList.findIndex((item) => item.fileId === file.fileId),
              1
            )
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
      }
    },
    fnGoBack() {
      window.close()
    },
    downloadTemplate() {
      var url = 'Contract/DownloadTemplate'
      this.downloadfile(this.baseURL + url)
    },
    beforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      var name = file.name.substring(0, file.name.lastIndexOf('.'))
      var extension = testmsg === 'pdf' || testmsg === 'PDF'
      if (!extension) {
        this.$message({
          message: '上传文件只能是pdf格式!',
          type: 'warning'
        })
      }
      if (name != '产品技术规格书' && name != '货物清单') {
        extension = false
        this.$message({
          message: '文件名不符合要求，必须为《产品技术规格书》或《货物清单》（不包含书名号），请重新上传！',
          type: 'warning'
        })
      }

      return extension
    },
    fnAddRatio() {
      var paymentRatio = {
        PaymentEntry: '',
        PaymentEntryName: '',
        PaymentDescribe: '',
        Ratio: '',
        IsRedio: false
      }
      this.contract.paymentRatioList.push(paymentRatio)
    },
    fnDelRatio(index) {
      this.contract.paymentRatioList.splice(index, 1)
    },
    RatioChange(item1, index) {
      var item = this.paymentRatioParamList[this.paymentRatioParamList.findIndex((m) => m.value == item1.PaymentEntry)]
      this.contract.paymentRatioList[index].PaymentEntryName = item.text
      this.contract.paymentRatioList[index].Ratio = item.fee
      this.contract.paymentRatioList[index].IsRedio = item.isredio
      this.contract.paymentRatioList[index].PaymentDescribe = item.describe
    },
    fnReadPdf(fileId) {
      let routerData = this.$router.resolve({
        path: 'ReadPDF',
        query: {
          fileId: fileId
        }
      })
      window.open(routerData.href, '_blank')
    },
    fnReadPdf1(fileId) {
      this.contract.isSubmit = false
      let contractStr = JSON.stringify(this.contract)
      let projectStr = JSON.stringify(this.instrumentList)
      console.log(contractStr)
      console.log(projectStr)
      this.postRequest('/Contract/SaveContract', {
        contractStr: contractStr,
        projectStr: projectStr
      }).then((res) => {
        if (res.data.errcode == 0) {
          this.getData()
          let routerData = this.$router.resolve({
            path: 'ReadPDF',
            query: {
              fileId: this.contract.FileId
            }
          })
          window.open(routerData.href, '_blank')
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    fnDownload(fileId) {
      let token = window.localStorage.getItem('loginToken')
      var url = 'Common/DownLoadFile?fileId=' + fileId + '&token=' + token + '&fileName='
      this.downloadfile(this.baseURL + url)
    },
    fnSave() {
      console.log(this.$refs['form'])
      let flag = true
      let that = this
      // if (
      //   Number(this.contract.AdvanceFee) +
      //     Number(this.contract.AcceptanceFee) +
      //     Number(this.contract.WarrantyFee) !=
      //   100
      // ) {
      //   this.$message.error("预付款比例、验收款比例、质保款比例之和需等于100");
      //   flag = false;
      //   return;
      // }
      if (this.contract.paymentRatioList.length == 0 && flag == true) {
        this.$message.error('请选择付款比例')
        flag = false
        return
      }
      if (
        this.contract.paymentRatioList.filter((item) => {
          return item.IsRedio == true
        }).length > 1 &&
        flag == true
      ) {
        this.$message.error('选择了相同类型的付款比例款项，请重新选择')
        flag = false
        return
      }

      var sum = 0
      var sumFee = 0
      for (var i = 0; i < this.contract.paymentRatioList.length; i++) {
        if (this.contract.paymentRatioList[i].Ratio == 0 && flag == true) {
          this.$message.error('请填写付款比例第' + Number(i + 1) + '项的比例！')
          flag = false
          break
        }
        if (this.contract.paymentRatioList[i].PaymentDescribe == '' && flag == true) {
          this.$message.error('请填写付款比例第' + Number(i + 1) + '项的描述！')
          flag = false
          break
        }
        if (
          this.contract.paymentRatioList.filter((item) => {
            return item.PaymentEntry == this.contract.paymentRatioList[i].PaymentEntry
          }).length > 1 &&
          flag == true
        ) {
          this.$message.error('选择了相同的付款比例款项，请重新选择')
          flag = false
          return
        }
        sum += this.contract.paymentRatioList[i].Ratio
      }
      if (sum != 100 && this.contract.flag == true) {
        this.$message.error('所选付款比例之和不为100，请重新选择！')
        flag = false
        return
      }
      this.instrumentList.forEach(function (instrument, index) {
        sumFee += instrument.Total
        if (instrument.SupplierInstrumentName == '' || instrument.SupplierInstrumentName == null) {
          that.$message.error(`请填写${instrument.InstrumentName}的货物名称`)
          flag = false
          return false
        }
        if (instrument.SupplierSpecification == '' || instrument.SupplierSpecification == null) {
          that.$message.error(`请填写${instrument.InstrumentName}的型号`)
          flag = false
          return false
        }
        if (instrument.Trademark == '' || instrument.Trademark == null) {
          that.$message.error(`请填写${instrument.InstrumentName}的品牌`)
          flag = false
          return false
        }
        if (isNaN(instrument.Price) || instrument.Price == '' || instrument.Price == null) {
          that.$message.error(`请填写${instrument.InstrumentName}的价格`)
          flag = false
          return false
        }
        if (instrument.Price <= 0) {
          that.$message.error(`${instrument.InstrumentName}的价格必须大于0`)
          flag = false
          return false
        }
        if (isNaN(instrument.Count) || instrument.Count == '' || instrument.Count == null) {
          that.$message.error(`请填写${instrument.InstrumentName}的数量`)
          flag = false
          return false
        }
        if (isNaN(instrument.DeliveryTerm) || instrument.DeliveryTerm == '' || instrument.DeliveryTerm == null) {
          that.$message.error(`请填写${instrument.InstrumentName}的货期`)
          flag = false
          return false
        }
        if (isNaN(instrument.TestCycle)) {
          that.$message.error(`请填写${instrument.InstrumentName}的安装调试期`)
          flag = false
          return false
        }
        if (isNaN(instrument.WarrantyPeriod) || instrument.WarrantyPeriod == '' || instrument.WarrantyPeriod == null) {
          that.$message.error(`请填写${instrument.InstrumentName}的质保期`)
          flag = false
          return false
        }
        if (instrument.WarrantyPeriodUnit == '' || instrument.WarrantyPeriodUnit == null) {
          that.$message.error(`请填写${instrument.InstrumentName}的质保期单位`)
          flag = false
          return false
        }

        if (instrument.Count < 0) {
          that.$message.error(`${instrument.InstrumentName}的数量必须大于0`)
          flag = false
          return false
        }
      })

      if (this.contract.PurchaseMethod == 1 && Number(sumFee) > Number(this.contract.TotalTenderAmount)) {
        this.$message.error('公标项目合同金额不得大于中标金额！')
        flag = false
        return
      }
      if (flag) {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.contract.isSubmit = true
            let contractStr = JSON.stringify(this.contract)
            let projectStr = JSON.stringify(this.instrumentList)
            console.log(contractStr)
            console.log(projectStr)
            this.postRequest('/Contract/SaveContract', {
              contractStr: contractStr,
              projectStr: projectStr
            }).then((res) => {
              if (res.data.errcode == 0) {
                this.$message.success('保存成功')
                localStorage.setItem('contractList', Math.random())
                window.close()
              } else {
                this.$message.error(res.data.errmsg)
              }
            })
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep.self_form {
  display: flex;

  .el-form-item .el-form-item__label {
    border: none !important;
    background: none !important;
    flex: 0 0 150px !important;
  }

  .el-form-item .el-form-item__content {
    border: none !important;
  }

  .el-form-item .el-form-item__content .el-input {
    width: 9.375rem;
  }

  .self_form1 {
    width: 33.3%;
  }
}

.content_wrap {
  padding-bottom: 20px;
  margin-bottom: 20px;
}

.changeInform_btn_wrap {
  width: 366px;
  margin: 40px auto 0;

  .btn_1 {
    background: #055ba9;
    color: #fff;
    border: none;
  }
}

.supplierType {
  .el-form-item {
    display: inline-block;
    flex: 0 0 200px;

    .el-input {
      width: 200px;
    }
  }

  .supplierOtherType {
    ::v-deep.el-form-item__content {
      border-bottom: none;
    }
  }
}

::v-deep.businessTermDate {
  .el-form-item__content {
    align-items: center;
  }

  .term {
    margin-top: 0 !important;
    margin-left: 0 !important;
  }

  .el-input {
    width: 300px;
    margin-right: 8px;
  }

  .businessTermEndDate {
    margin-bottom: 0 !important;

    .el-input {
      width: 100% !important;
    }

    .el-form-item__label:before {
      display: none;
    }

    .el-form-item__content {
      border-bottom: none;
    }
  }
}

::v-deep.el-form-item {
  .el-input.is-disabled .el-input__inner,
  .el-select .el-input.is-disabled .el-input__inner,
  .el-checkbox__input.is-disabled + span.el-checkbox__label,
  .el-textarea.is-disabled .el-textarea__inner {
    color: #606266;
  }
}

.back_btn {
  height: 26px;
  bottom: 7px;
  padding: 0 18px;
  border-radius: 14px;
}

.businessTermDate1 ::v-deep.el-input__inner {
  min-width: 150px !important;
}

.tableWrap5_custom ::v-deep.btn_wrap {
  margin-right: 12px;
  margin-top: 15px;
}

.tableWrap5_custom ::v-deep.tab_wrap5 {
  margin: 0 15px 15px;

  .product_form {
    margin-bottom: 0;
  }
}

.change_inform ::v-deep.icon_tips2 {
  vertical-align: middle !important;
}

.change_inform ::v-deep.el-form-item__content {
  display: block !important;
}

.rangeDate ::v-deep.el-form-item__content {
  .el-input__inner,
  .el-range-editor {
    width: 300px;
    margin-right: 8px;
    text-align: center;

    .el-range-input {
      font-size: 14px;
    }
  }
}

.tree ::v-deep .el-tree-node {
  .el-tree-node__children {
    white-space: normal;

    .el-tree-node {
      display: inline-block;
    }
  }
}

.otherinput {
  height: 25px;
  line-height: 40px;
  width: 100%;
}

.width_full {
  width: 100% !important;
}

.statistics_table {
  width: 99%;
  table-layout: fixed;

  th {
    padding: 6px 0;
    text-align: center !important;
    background: #d8eafa !important;
    color: #046663;
    font-weight: normal !important;
    border: 1px solid #95c7f0;
    vertical-align: middle;
    white-space: nowrap;
  }

  td {
    padding: 6px 12px;
    border: 1px solid #95c7f0;
    background: #fff !important;
    text-align: center;
  }

  tr {
    border-bottom: 1px solid #95c7f0;
  }
}

.file_wrap {
  width: 18rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.input_number {
  padding-right: 2rem;
}

.input_number ::v-deep.el-input__inner {
  width: 45% !important;
}

.input_select ::v-deep .el-input {
  width: 75% !important;
}

.input_number1 {
  padding-right: 1rem;
}

.input_number1 ::v-deep.el-input__inner {
  width: 100% !important;
}
</style>